import { EVENT_KEY, TRACKING_ACTION, TRACKING_INTERACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const timetableTracking = {
  trackTimetable (entity = 'timetable', result = 'SUCCESS', failedReason = null) {
    const interaction = {
      clickClass: ({ trackGlobal = null }) => trackingUtils.track(EVENT_KEY.TIMETABLE.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_CLASS, entity, trackGlobal })
    }

    const start = {
      export: () => trackingUtils.track(EVENT_KEY.TIMETABLE.START, { action: TRACKING_ACTION.EXPORT, entity })
    }

    const end = {
      export: () => trackingUtils.trackWithResult(EVENT_KEY.TIMETABLE.END, { action: TRACKING_ACTION.EXPORT, entity, result, failedReason })
    }

    return {
      interaction,
      end,
      start
    }
  }
}

export default timetableTracking
